import { KButton, KDropdown, KSelectRange, KSpan } from "kahuna-base-react-components"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import React, { useEffect, useState } from "react"
import { AdminUserFilterType } from "../AdminUser"

const UserDistributionTypeOptions: KSelectOption[] = [
  { label: "Advance", value: 1, value2: "advance" },
  { label: "Distribution", value: 2, value2: "distribution" }
]

const AdminUserFilter = ({
  onApplyFilter,
  filter,
  setFilter
}: {
  onApplyFilter: () => void
  filter: AdminUserFilterType
  setFilter: (filter: AdminUserFilterType) => void
}) => {
  return (
    <div className="flex flex-row justify-between gap-3">
      <div className="flex flex-row gap-3" style={{ width: "100%" }}>
        <KSelectRange
          value={filter.dateValues}
          onChange={(event) => setFilter({ ...filter, dateValues: event })}
          height="36px"
          width="auto"
          backgroundColor="#F7F7F7"
          hoverBackgroundColor="#F3F3F3"
          boxShadow="none"
          align={"center"}
        />
        {filter.dateValues && filter.dateValues[0] && filter.dateValues[1] && (
          <div className="flex flex-row gap-1 h-9 items-center px-1">
            <KSpan
              text={`${filter.dateValues[0].toLocaleDateString("en-US", {
                month: "short",
                year: "numeric"
              })} - ${filter.dateValues[1].toLocaleDateString("en-US", { month: "short", year: "numeric" })}`}
              color="#000"
              fontWeight={500}
            />
            <div className="cursor-pointer" onClick={() => setFilter({ ...filter, dateValues: [null, null] })}>
              <img className="rounded-full hover:bg-[#F3F3F3]" src="/admin_icons/close.svg" />
            </div>
          </div>
        )}
        <KDropdown
          width={140}
          menuWidth={160}
          isClearable
          placeholder="Distribution Type"
          selected={filter.distributionType}
          options={UserDistributionTypeOptions}
          onSelect={(selected) => setFilter({ ...filter, distributionType: selected as KSelectOption })}
        />
      </div>
      <div>
        <KButton
          width="120px"
          text="Apply Filters"
          background="transparent"
          height="36px"
          onClick={() => onApplyFilter()}
        />
      </div>
    </div>
  )
}

export default AdminUserFilter
